module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_26_B_1.60111a92.mp3";